import React, { useContext, useState } from 'react';
import ImageClusterPreview from './ImageClusterPreview';
import useAsyncEffect from '../common/react-hooks/useAsyncEffect';
import LegoAdminPageContext from '../../pages/legoAdminPageContext';
import { IconButton } from '../common/IconButton';
import BadgeColorHash from '../common/BadgeColorHash';
import { clearCacheByUrlAndId } from '../common/react-hooks/useGetCachedDocIdBatched';

export default function ModalMergeImageClusters({ clusters, onSave, onCancel }) {
  const { page } = useContext(LegoAdminPageContext);

  const [[a, b], setAB] = useState(clusters);

  const swapClusters = () => setAB([b, a]);

  const [changesEstimate, setChangesEstimate] = useState(null);

  useAsyncEffect(async () => {
    setChangesEstimate(null);
    try {
      const estimate = await page.service('/services/data/image-clusters/operations').find({ query: { operation: 'merge', fromId: a._id, intoId: b._id } });
      setChangesEstimate(estimate);
    } catch (error) {
      page.alert(error.message);
    }
  }, [a, b]);

  const mergeClusters = () => {
    page.runAsync(async () => {
      await page.service('/services/data/image-clusters/operations').create({ operation: 'merge', fromId: a._id, intoId: b._id });
      onSave();
      // Clear the image cluster image preview cache so that the UI does not show outdated images
      clearCacheByUrlAndId('services/data/image-clusters', a._id);
      clearCacheByUrlAndId('services/data/image-clusters', b._id);
    }, 'Merging clusters...');
  }

  let estimate = <div>Loading estimate...</div>;
  if (changesEstimate) {
    estimate = <pre>{JSON.stringify(changesEstimate, null, 2)}</pre>;
  }

  const crossModel = a?.context?.modelId && b?.context?.modelId && a.context.modelId !== b.context.modelId;

  return (
    <div>
      <div>
        <div className='bg-light-danger p-2'>
          MERGE <BadgeColorHash id={a._id} /> (model {a.context?.modelId}):<br/>
          <ImageClusterPreview clusterId={a._id} maxImages={15} />
        </div>
        <div className='bg-light-success p-2'>
          INTO <BadgeColorHash id={b._id} /> (model {b.context?.modelId}):<br/>
          <ImageClusterPreview clusterId={b._id} maxImages={15} />
        </div>
        <IconButton icon='swap_horiz' level='primary' onClick={swapClusters}>Swap which cluster is being merged</IconButton>
      </div>

      {crossModel ? <div className='alert alert-warning p-2 my-2'>
        Cross-model merge: fusebox references currently on model <strong>{a.context.modelId}</strong> will be repointed to the cluster of model <strong>{b.context.modelId}</strong>.
        DataIssues will be retargeted to <strong>{b.context.modelId}</strong>; DataFeedback records remain on their original models.
      </div> : null}

      <div style={{minHeight: '100px'}} className='bg-light'>
        {estimate}
      </div>

      <div className='text-center'>
        <button className='btn btn-primary' onClick={mergeClusters}>Merge</button>
        <button className='btn btn-secondary' onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
